import { Mesh } from 'three';
import React from 'react';

export default {
    name: '[pipe]triple',
    prototype: 'holes',

    info: {
        tag: ['triple'],
        title: 'Triple',
        description: 'Triple',
        image: require('./triple.png')
    },

    properties: {
        width: {
            label: 'Width',
            type: 'length-measure',
            defaultValue: {
                length: 50
            }
        },
        flip_orizzontal: {
            label: 'flip orizzontale',
            type: 'checkbox',
            defaultValue: false,
            values: {
                'none': false,
                'yes': true
            }
        },
    },

    render2D: function (element, layer, scene) {

        let width = element.properties.get('width').get('length');
        let flip = element.properties.get('flip_orizzontal');

        if (flip === false) {
            return (
                <g transform={`scale(${width * 0.05} ${width * 0.05}) translate(6, -1.5) rotate(180)`}>
                    <path d="M0 0 L12 0 L12 -3 L8 -3 L8 -6 L4 -6 L4 -3 L0 -3 z" stroke="#000000" fill="#000000" />
                </g>
            )
        } else {
            return (
                <g transform={`scale(${width * 0.05} ${width * 0.05}) translate(-6, 1.5)`}>
                    <path d="M0 0 L12 0 L12 -3 L8 -3 L8 -6 L4 -6 L4 -3 L0 -3 z" stroke="#000000" fill="#000000" />
                </g>

            )
        }

    },

    render3D: function (element, layer, scene) {
        let mesh = new Mesh();
        return Promise.resolve(mesh);
    }
};
